import { useRef } from 'react';
import Career from 'wwg-utilities/dist/collections/career';
import Play from '../../icons/Play';
import Image from "next/legacy/image";
import {
  getPublicIDFromURL,
  getResizedImageURL,
} from '../../../lib/cloudinary';
import Photo from 'wwg-utilities/dist/collections/photo';

interface VideoProps {
  career: Career;
}

const Video: React.FC<VideoProps> = ({ career }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const playVideo = () => {
    buttonRef.current?.classList.add('hidden');
    videoRef.current?.play();
  };

  const onPause = () => {
    buttonRef.current?.classList.remove('hidden');
  };

  return (
    <section className="relative max-h-[471px]">
      {career?.video?.url ? (
        <>
          <video
            ref={videoRef}
            controls
            className="object-cover w-full h-full cursor-pointer -mt-28 md:-mt-44 rounded-2xl md:rounded-careerImg"
            poster={getResizedImageURL(
              (career.photo as Photo)?.public_id ||
                getPublicIDFromURL(career.video.poster) ||
                '',
              836,
              471,
            )}
            onPause={onPause}
          >
            <source src={career?.video?.url} type="video/mp4" />
          </video>
          <button
            onClick={playVideo}
            ref={buttonRef}
            className="absolute top-[38%] left-[40%] md:top-[42%] md:left-[45%]"
          >
            <Play className="w-10 h-10 cursor-pointer md:h-20 md:w-20 fill-white/50" />
          </button>
        </>
      ) : (
        <figure className="max-h-[471px]">
          <Image
            src={career?.video?.poster || ''}
            className="w-full h-full cursor-pointer -mt-28 md:-mt-44 rounded-2xl md:rounded-careerImg"
            blurDataURL={career.video?.poster}
            layout="responsive"
            loading="eager"
            placeholder="blur"
            width={1050}
            height={475}
            alt=""
          />
        </figure>
      )}
    </section>
  );
};

export default Video;
